import React, { Fragment } from 'react';
import PageTitle from '../../components/pagetitle/PageTitle';
import Navbar from '../../components/Navbar/Navbar';
import Contactpage from '../../components/Contactpage/Contactpage';
import ConsultingArea from '../../components/ConsultingArea/ConsultingArea';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';
//import Newsletter from '../../components/Newsletter/Newsletter';

const ContactPage = () => {
	return (
		<Fragment>
			<Navbar />
			<PageTitle pageTitle={'Contactez-nous'} pagesub={'Contact'} />
			<Contactpage />
			<ConsultingArea />
			<Footer />
			<Scrollbar />
		</Fragment>
	);
};
export default ContactPage;
